import * as React from 'react';
import { AppDesignScheme } from '../../weborder/Api';
import { getTranslate, Translate } from 'react-localize-redux';
import { AccessibilityButton } from '../AccessibilityButton/AccessibilityButton';
import Radium from '@flipdish/radium';

const tinycolor = require('tinycolor2');

type Props = {
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;
  textId: TranslationId;
  dataFd: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};
type State = {
  checked: boolean;
};

class CheckBoxOld extends React.Component<Props, State> {
  static getDerivedStateFromProps(props, state) {
    if (props.checked !== state.checked) {
      return {
        ...state,
        checked: props.checked
      };
    }

    return null;
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      checked: false
    };
  }

  public handleChange = () => {
    const checked = !this.state.checked;
    this.setState({
      ...this.state,
      checked
    });

    if (this.props.onChange) {
      this.props.onChange(checked);
    }
  };

  public render() {
    const styles = {
      primary: {
        color: this.props.AppDesignScheme.Primary
      },
      secondary: {
        color: this.props.AppDesignScheme.Secondary
      },
      secondaryActive: {
        color: tinycolor(this.props.AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      tertiary: {
        color: this.props.AppDesignScheme.Tertiary
      },
      checkbox: {
        paddingTop: '1px',
        paddingBottom: '2px',
        color: this.props.AppDesignScheme.Tertiary,
        ':hover': {
          color: this.props.AppDesignScheme.Secondary
        },
        ':active': {
          color: tinycolor(this.props.AppDesignScheme.Secondary)
            .darken(10)
            .toString()
        }
      },
      darkCheckbox: {
        paddingTop: '1px',
        paddingBottom: '2px',
        color: this.props.AppDesignScheme.Primary,
        ':hover': {
          color: this.props.AppDesignScheme.Secondary
        },
        ':active': {
          color: tinycolor(this.props.AppDesignScheme.Secondary)
            .darken(10)
            .toString()
        }
      }
    };
    return (
      <AccessibilityButton
        dataFd={this.props.dataFd}
        onClick={this.handleChange}
        className="flex flex-align-center  menu__sidepanel__item menu__sidepanel__item--checkbox"
      >
        <i
          className={`tertiary fa ${
            this.state.checked ? 'fa-check-square-o-web-order' : 'fa-square-o-web-order '
          }`}
          style={this.props.isDark ? styles.darkCheckbox : styles.checkbox}
          key="checkbox"
          data-fd={this.props.dataFd}
        />
        <p
          className="clear-margins tertiary fd-h4"
          style={this.props.isDark ? styles.primary : styles.tertiary}
        >
          <Translate id={this.props.textId} />
        </p>
      </AccessibilityButton>
    );
  }
}

export default Radium(CheckBoxOld);
